import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { ensureSharedBackend } from '@/api/client';

// Suppress benign ResizeObserver errors (common with Dialog/Select components)
const resizeObserverErrorHandler = (e) => {
  if (e.message === 'ResizeObserver loop completed with undelivered notifications.') {
    const resizeObserverErrDiv = document.getElementById('webpack-dev-server-client-overlay-div');
    const resizeObserverErr = document.getElementById('webpack-dev-server-client-overlay');
    if (resizeObserverErr) resizeObserverErr.setAttribute('style', 'display: none');
    if (resizeObserverErrDiv) resizeObserverErrDiv.setAttribute('style', 'display: none');
  }
};

window.addEventListener('error', resizeObserverErrorHandler);

// Verify shared backend connection
ensureSharedBackend().catch(err => {
  console.error('[R2YN] Failed to connect to shared backend:', err);
  console.warn('[R2YN] App will continue, but shared features may not work');
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
